/* globals getURLParameter */
/* eslint-disable complexity, max-statements */
(function($) {
  'use strict';
  var $uniForm = $('.uni-form');
  var $submit = $uniForm.find('[type="submit"]');
  var $formHeading = $uniForm.prevAll('h2');
  var $inPageNav = $('.inpage-nav');
  var $token = $('#elqFormSubmissionToken');
  var siteID = $uniForm.find('[name="elqSiteID"]').val();
  var $lastFormRow = $('#elq-FormLastRow');

  var studentTypeField = document.getElementById('student_type');
  var trimesterStartField = document.getElementById('trimester_start');
  var nationality = document.getElementById('nationality_container');
  var nationalityField = document.getElementById('nationality');
  var campusPreference = document.getElementById('campus_preference_container');
  var campusPreferenceField = document.getElementById('campus_preference');
  var studyPreference = document.getElementById('i_want_to_study_container');
  var studyPreferenceField = document.getElementById('i_want_to_study');

  if ($uniForm && $token && siteID && $lastFormRow) {
    $lastFormRow.hide();
    var hostName = new URL($uniForm.attr('action')).origin;
    var url = `${hostName}/e/formsubmittoken?elqSiteID=${siteID}`;
    $.get(url)
      .done(function(response, status) {
        if (status === 'success') {
          $token.val(response);
        }
      })
      .fail(function(error, status) {
        console.error(status);
      });
    $uniForm
      .find('input, select')
      .not($token)
      .one('change', function() {
        $submit.prop('disabled', false);
      });
    $uniForm.on('submit', function() {
      if ($uniForm.valid()) {
        $submit
          .prop('disabled', true)
          .addClass('sq-button-inactive')
          .html('Submitting <i class="sq-form-submit-loading"></i>');
      }
    });
  }

  if (
    campusPreference &&
    campusPreferenceField &&
    studyPreference &&
    studyPreferenceField
  ) {
    campusPreference.style.display = 'none';
    campusPreferenceField.required = false;
    if (trimesterStartField || studentTypeField) {
      studyPreference.style.display = 'none';
      studyPreferenceField.required = false;
    }

    if (studentTypeField && nationality) {
      nationality.style.display = 'none';
      nationalityField.required = false;
      studentTypeField.addEventListener('change', function() {
        if (this.value === 'International') {
          nationality.style.display = 'block';
          nationalityField.required = true;
          studyPreference.style.display = 'block';
          studyPreferenceField.required = true;
        } else {
          nationality.style.display = 'none';
          nationalityField.required = false;
          campusPreference.style.display = 'none';
          campusPreferenceField.required = false;
          studyPreference.style.display = 'none';
          studyPreferenceField.required = false;
        }
      });
    }

    studyPreferenceField.addEventListener('change', function() {
      if (this.value === 'On Campus') {
        campusPreference.style.display = 'block';
        campusPreferenceField.required = true;
      } else {
        campusPreference.style.display = 'none';
        campusPreferenceField.required = false;
      }
    });
  }

  if (
    $uniForm.length &&
    $formHeading.length &&
    getURLParameter('submitted') === 'true'
  ) {
    var headingTop = $formHeading.offset().top;
    $formHeading.next('p').remove();
    $uniForm.replaceWith(
      '<p id="subscribe-form">Thanks for connecting! We\'ll be in touch.</p>'
    );

    var scrollPosition = $inPageNav.length
      ? headingTop - $inPageNav.outerHeight() - 50
      : headingTop;

    $('html, body')
      .stop()
      .animate(
        {
          scrollTop: scrollPosition,
        },
        500,
        'swing'
      );
  }
})(jQuery);
